import { getData } from "@/lib/prismic/data";
import { SliceZone } from "@prismicio/react";
import { notFound } from "next/navigation";
import { use } from "react";
import { components } from "@/slices";
import Hero from "@/components/blocks/hero";
import OurServices from "@/components/organisms/our-services";

const Homepage = ({ resolution }: TemplateProps) => {
  const document = use(getData(resolution));

  if (!document) return notFound();

  return (
    <>
      <Hero locale={resolution.locale} />
      <SliceZone slices={document.data.slices} components={components} context={{ locale: resolution.locale }} />
      <OurServices locale={resolution.locale} />
    </>
  );
};

export default Homepage;
